// Variantes coloridas usam os tokens semânticos do tailwind.config.js
// (receita padrão de pill: bg-X-soft dark:bg-X-900/30 text-X-text dark:text-X-300).
const variantClasses = {
    default: 'bg-mono-100 dark:bg-mono-900 text-mono-700 dark:text-mono-300',
    success: 'bg-success-soft dark:bg-success-900/30 text-success-text dark:text-success-300',
    warning: 'bg-warning-soft dark:bg-warning-900/30 text-warning-text dark:text-warning-300',
    danger: 'bg-danger-soft dark:bg-danger-900/30 text-danger-text dark:text-danger-300',
    info: 'bg-info-soft dark:bg-info-900/30 text-info-text dark:text-info-300',
    neutral: 'bg-mono-100 dark:bg-mono-800 text-mono-500 dark:text-mono-400',
};

const Badge = ({ children, variant = 'default', className = '' }) => {
    const variantClass = variantClasses[variant] || variantClasses.default;

    return (
        <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${variantClass} ${className}`}>
            {children}
        </span>
    );
};

export default Badge;
